
import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'danger';
  isLoading?: boolean;
}

const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  isLoading, 
  className = '', 
  ...props 
}) => {
  const baseStyles = 'px-8 py-4 rounded-3xl font-black transition-all duration-500 active:scale-95 disabled:opacity-50 disabled:pointer-events-none flex items-center justify-center gap-3 text-[11px] uppercase tracking-[0.25em]';
  
  const variants = {
    primary: 'bg-brand-primary text-black hover:shadow-[0_0_30px_rgba(255,206,27,0.4)] hover:scale-[1.02]',
    secondary: 'bg-white/5 text-white hover:bg-white/10 border border-white/10 backdrop-blur-md',
    outline: 'bg-transparent border-2 border-brand-primary/50 text-brand-primary hover:border-brand-primary hover:bg-brand-primary/5',
    danger: 'bg-red-500/10 text-red-500 hover:bg-red-500 hover:text-white border border-red-500/20'
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${className}`}
      disabled={isLoading}
      {...props}
    >
      {isLoading ? (
        <span className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
      ) : children}
    </button>
  );
};

export default Button;
